"use client";
import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";

import { Button, buttonVariants } from "./ui/button";
import { Separator } from "./ui/separator";
import { useSignOut } from "@/lib/utils/supabase/client";
import LewkLoader from "./c-loader";
import Link from "next/link";

interface accountAvatartProps {
  email: string | undefined;
  profilePicURL: string;
}

const AccountAvatar: React.FC<accountAvatartProps> = ({
  email,
  profilePicURL,
}) => {
  const { signOut, loading } = useSignOut();
  return (
    <Popover>
      <PopoverTrigger>
        <Avatar>
          <AvatarImage src={profilePicURL} />
          <AvatarFallback className=" capitalize">
            {email?.split("")[0] || "NA"}
          </AvatarFallback>
        </Avatar>
      </PopoverTrigger>
      <PopoverContent
        className="flex flex-col items-center gap-y-2  rounded-base shadow-container border border-lewk-grey"
        sideOffset={5}
      >
        <p className="">{email}</p>

        <Link
          className={buttonVariants({ variant: "secondary", size: "full_w" })}
          target="_blank"
          href={"https://www.shopthelewk.com/reportaproblem"}
        >
          Contact Us
        </Link>
        {/* <Button variant={"secondary"} size={"full_w"}>
          Sample Button
        </Button> */}
        

        <Separator />
        <Button
          disabled={loading}
          onClick={() => signOut()}
          variant={"primary"}
          size={"full_w"}
        >
          {loading ? <LewkLoader className=" size-10" /> : "Sign Out"}
        </Button>
      </PopoverContent>
    </Popover>
  );
};

export default AccountAvatar;
